<template>
  <div id='subjectBalance'>
    <div class="public-content ">
      <el-form inline label-position="left">
        <el-form-item label="科目余额表">
          <accounting-period @defaultTime='defaultTime'></accounting-period>
        </el-form-item>
        <el-form-item label="科目级次">
          <el-select size="mini" style="width: 120px" v-model='form.level'>
            <el-option v-for='item in options' :label='item.label' :value='item.value' :key='item.value'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class='isChildrenShow'>
          <el-checkbox @change="handleCheck" v-model='form.isChildrenShow'>显示数量</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox @change="handleCheckAuxiliary" v-model='form.isShowAuxiliary'>显示辅助核算</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" class='minButton' @click='getTableList' type = "primary">
            搜索
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" class='minButton' @click='handleExpandAll'>
            全部{{tableData.defaultExpandAll?"收起":"展开" }}
          </el-button>
        </el-form-item>
        <el-form-item class='right-position'>
          <el-button size="mini" @click="showPrintCover = true">连续打印</el-button>
          <print-operation :formData="printForm" :showContinuit="false"></print-operation>
          <!-- <print-operation
							:formData="printForm"
							:showContinuit="false"
						></print-operation> -->
          <el-button size='mini' @click="handleDownload">导出</el-button>
        </el-form-item>
      </el-form>

      <public-table :table="tableData" v-if='refresh'>
        <template slot-scope="props" slot="subjectName">
          <el-button type='text' v-if='props.scope.row.subjectName != "合计"'
            @click='handleClickRow(props.scope.row)'>{{ props.scope.row.subjectName }}</el-button>
          <span v-else>{{ props.scope.row.subjectName }}</span>
        </template>
      </public-table>
    </div>

    <PrintCover :isShow="showPrintCover" @close="showPrintCover = false" @print="continuityPrint($event)" />

  </div>
</template>
<script>
import publicTable from '@/components/publicTable'
import accountingPeriod from '@/components/dialog/accountingPeriod'
import printOperation from '@/components/print'
import { currencys } from '@/assets/utils/currencyFormat'
import PrintCover from './com/printCover.vue'

export default {
  components: {
    publicTable,
    accountingPeriod,
    printOperation,
    PrintCover
  },
  data() {
    return {
      printForm: {        // 打印参数
        data: {
          start: '',
          end: '',
          level: '',
          isShowAuxiliary: false,   // 是否显示辅助核算
        },
        url: '/createPDF/printSubsidiaryLedger',
        continuityUrl: '/createPDF/printSubsidiaryLedger'
      },
      showPrintCover: false,
      firstGet: true,   // 请求一次
      options: [{
        value: 1,
        label: '一级'
      }, {
        value: 2,
        label: '二级'
      }, {
        value: 3,
        label: '三级'
      }, {
        value: 4,
        label: '四级'
      }, {
        value: 5,
        label: '五级'
      }],
      form: {
        start: '',
        end: '',
        level: 1,
        isShowAuxiliary: false,   // 是否显示辅助核算
        isChildrenShow: false,   // 是否显示数量
      },
      refresh: true,            // 刷新表格

      tableData: {
        defaultExpandAll: false,
        border: true,				// 是否带有纵向边框
        stripe: true,				// 是否带有斑马纹
        loading: false,				// 是否显示加载动画
        hasSelect: false,			// 是否显示多选
        hasOperation: false,		// 是否有操作功能
        hasContextmenu: false,		// 是否有右键功能
        hasShowSummary: false,		// 是否显示合计行
        hasShowPagination: false,	// 是否显示分页
        config: [{
          label: '科目编码',
          value: 'code',
          align: "left",
          show: 'normal'
        }, {
          label: '科目名称',
          value: 'subjectName',
          show: 'template'
        }, {
          label: '期初余额',
          value: 'initial',
          show: 'normal',
          showChild: true,
          children: [{
            label: '借方数量',
            value: 'initialDebitAmount',
            show: 'normal',
            isShow: true,
            sign: true
          }, {
            label: '借方金额',
            value: 'balanceDebit',
            formatter: this.formatter,
            show: 'normal',
          }, {
            label: '贷方数量',
            value: 'initialCreditorAmount',
            show: 'normal',
            isShow: true,
            sign: true
          }, {
            label: '贷方金额',
            value: 'balanceCreditor',
            formatter: this.formatter,
            show: 'normal',
          }]
        }, {
          label: '本期发生额',
          value: 'currentPeriod',
          show: 'normal',
          showChild: true,
          children: [{
            label: '借方数量',
            value: 'monDebitAmount',
            show: 'normal',
            isShow: true,
            sign: true
          }, {
            label: '借方金额',
            value: 'occurrencePeriodDebit',
            formatter: this.formatter,
            show: 'normal',
          }, {
            label: '贷方数量',
            value: 'monCreditorAmount',
            show: 'normal',
            isShow: true,
            sign: true
          }, {
            label: '贷方金额',
            value: 'occurrencePeriodCreditor',
            formatter: this.formatter,
            show: 'normal',
          }]
        }, {
          label: '本年累计发生额',
          value: 'currentYear',
          show: 'normal',
          showChild: true,
          children: [{
            label: '借方数量',
            value: 'yearDebitAmount',
            show: 'normal',
            isShow: true,
            sign: true
          }, {
            label: '借方金额',
            formatter: this.formatter,
            value: 'occurrenceYearDebit',
            show: 'normal',
          }, {
            label: '贷方数量',
            value: 'yearCreditorAmount',
            show: 'normal',
            isShow: true,
            sign: true
          }, {
            label: '贷方金额',
            formatter: this.formatter,
            value: 'occurrenceYearCreditor',
            show: 'normal',
          }]
        }, {
          label: '期末余额',
          value: 'terminal',
          show: 'normal',
          showChild: true,
          children: [{
            label: '借方数量',
            value: 'monEndDebitAmount',
            show: 'normal',
            isShow: true,
            sign: true
          }, {
            label: '借方金额',
            formatter: this.formatter,
            value: 'endBalanceDebit',
            show: 'normal',
          }, {
            label: '贷方数量',
            value: 'monEndCreditorAmount',
            show: 'normal',
            isShow: true,
            sign: true
          }, {
            label: '贷方金额',
            formatter: this.formatter,
            value: 'endBalanceCreditor',
            show: 'normal',
          }]
        }],
        data: [],
        page: {
          pageNo: 1,
          pageSize: 20,
          count: 10
        },
        center: {
          textAlign: 'center',
          padding: '6px 0'
        },
        cellFun: this.cellFun,
      },
    }
  },
  created() {

  },
  computed: {
    //获取tableData.config有嵌套表头的数据
    getTableDatas() {
      let getTableDatas = this.tableData.config.filter((item) => {
        if (item.children) {
          return item;
        }
      })
      return getTableDatas;
    },
    getClickCache() {
      return this.$store.state.loadstatus.isClickCache;
    },
  },

  activated() {
    if (this.getClickCache && this.isFirstActive) {
      this.getTableList();
    }
    this.isFirstActive = true;
  },
  methods: {
    cellFun({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0) {
        return {
          textAlign: 'left',
          padding: '6px 0'
        }
      }
      return {
          textAlign: 'center',
          padding: '6px 0'
        }
    },
    // 展开收起
		handleExpandAll() {
      this.tableData.defaultExpandAll = !this.tableData.defaultExpandAll
			this.refresh = false;
			this.$nextTick(()=>{
				this.refresh = true;
			})
		},
    /** 连续打印 */
    continuityPrint(form) {
      let printParams = Object.assign({}, this.printForm.data, {
        cid: sessionStorage.cid,
        token: sessionStorage.token,
        isCover: form.isCover,
      })
      printParams.isBatch = true
      const router = this.$router.resolve({
        path: this.printForm.url,
        query: printParams
      })

      this.showPrintCover = false
      window.open(this.$rootUrl + router.href, '_blank')
    },
    // 是否显示辅助核算
    handleCheckAuxiliary(val) {
      this.form.isShowAuxiliary = val;
      this.getTableList();
    },
    // 点击科目跳转明细账
    handleClickRow(row) {
      this.$router.push({ path: "/subsidiaryLedger", query: { subjectId: row.subjectId } })
    },
    // 表格格式化
    formatter(row, column, cellValue, index) {
      if (!row[column.property]) {
        return "";
      } else {
        return currencys(row[column.property]);
      }
    },
    // 导出
    handleDownload() {
      const params = {
        cid: sessionStorage.cid,
        token: sessionStorage.token,
        level: this.form.level,
        start: this.form.start,
        quantity: this.form.isChildrenShow,
        isShowAuxiliary: this.form.isShowAuxiliary,
        end: this.form.end,
      }

      const router = this.$router.resolve({
        path: '/export/listByLevelExport',
        query: params
      })

      window.open(this.$rootUrl + router.href, '_blank');
    },
    // 接收会计期间数据
    defaultTime(data) {
      this.form = Object.assign(this.form, {
        start: this.$util.formatDate.format(data.yearPeriodsStart, 'yyyyMM'),
        end: this.$util.formatDate.format(data.yearPeriodsEnd, 'yyyyMM'),
      })
      if (this.firstGet) {
        this.getTableList();
        this.firstGet = false;
      }
    },
    // 获取科目余额表
    getTableList() {
      try {
        this.tableData.loading = true;
        this.printForm.data = this.form;
        this.$http.post('subsidiaryLedger/getSubjectBalanceByLevel', this.form).then(res => {
          this.tableData.loading = false;
          if (res && res.data.code == 1) {
            this.tableData.data = res.data.data;
            this.tableData.data.forEach(item => {
              for (const i in item) {
                if (typeof item[i] === 'number') {
                  item[i] = item[i] === 0 ? '' : item[i];
                }
              }
            })
          }
          console.log('tableData.data', this.tableData.data);

        })
      } catch (e) {
        this.tableData.loading = false;
      }
    },
    //checkBox点击事件
    handleCheck() {
      let data = this.getTableDatas.find(item => item.value == "initial")
      let data1 = this.getTableDatas.find(item => item.value == "currentPeriod")
      let data2 = this.getTableDatas.find(item => item.value == "currentYear")
      let data3 = this.getTableDatas.find(item => item.value == "terminal")
      data.children.forEach(item => {
        if (item.sign) {
          item.isShow = !this.form.isChildrenShow
        }
      });
      data1.children.forEach(item => {
        if (item.sign) {
          item.isShow = !this.form.isChildrenShow
        }
      });
      data2.children.forEach(item => {
        if (item.sign) {
          item.isShow = !this.form.isChildrenShow
        }
      });
      data3.children.forEach(item => {
        if (item.sign) {
          item.isShow = !this.form.isChildrenShow
        }
      });
      if (!this.form.isChildrenShow) {
        this.refresh = false;
        this.$nextTick(() => {
          this.refresh = true;
        })
      };
    },
  },
  mounted() {

  }
}
</script>
<style lang='less' scoped>
#subjectBalance {
  .isChildrenShow {
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/accountBook/subjectBalance.vue